import { connect } from 'react-redux'

import {
  getEventByEventID,
  bulkUploadForEvents,
  resolveConflict,
} from '../../../Events/actions'
import { getEventByEventIDSwitch, getStatusUpdate, exportEventCandidate, getStatusUpdateBulk} from '../action'
import { getExportFiledData, exportCandidate } from '../../../JobRoles/actions'
// import selectors from '../../../ATS/selector'
import selectors from '../../selectors'
 import { getPreview  } from '../../../ATS/action'
import Event from '../index'

const mapStateToProps = state => ({
  previewData: selectors.getPreviewData(state),
  instituteCampusId: state.auth.instituteDetails.id,
  getEventId: selectors.getEventId(state),
})

const mapDispatchToProps = {
  getEventByEventID,
  getExportFiledData,
  exportCandidate,
  getEventByEventIDSwitch,
  bulkUploadForEvents,
  resolveConflict,
  getStatusUpdate,
  exportEventCandidate,
  getStatusUpdateBulk,
  getPreview
}

export default connect(mapStateToProps, mapDispatchToProps)(Event)
